import React from "react";
import PartnerFileShare from "./PartnerFileShare";
import styles from "./styles/SharedFilesModal.module.css";

/*
  The shared files on their own, for the partner.

  The customer reaches this panel inside the advisor modal, which is also
  where they edit that advisor. A partner must not: on their screen the
  promotion card is their OWN branding, and the advisor it would open is
  matched to the customer's list by NAME -- so it could open somebody
  else's record in edit mode. That is the reason the card's "See More" is
  dead for them.

  They still need the files, which is the whole point of the customer
  uploading them. So they get the panel by itself, in a window of its own,
  with nothing of the advisor attached.
*/
export default function SharedFilesModal({ partnerName, onClose }) {
  return (
    <div
      className={styles.backdrop}
      /*
        Closing by clicking away, but only on the backdrop itself -- a
        click that started inside the card and drifted out should not shut
        it, which is what listening on the whole subtree would do.
      */
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={styles.card} role="dialog" aria-modal="true">
        <button
          type="button"
          className={styles.close}
          aria-label="Close"
          onClick={onClose}
        />
        <PartnerFileShare partnerName={partnerName} />
      </div>
    </div>
  );
}
